exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".label-browse {\n    margin-left: 8px;\n    font-weight: normal;\n}\n\n.bold {\n    font-weight: bold;\n}\n\n.support-container{\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: end;\n      align-content: flex-end;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-flow: wrap;\n      flex-flow: wrap;\n  width: 100%;\n  margin-bottom: 25px;\n}\n\n.form-container div{\n  margin-bottom: 15px;\n}\n\n.form-container ul{\n  border-bottom: 1px dashed #6C7174;\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/support/support.component.css
// module id = 808
// module chunks = 0